function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'cuero': 'rgb(228, 131, 45)','negro': 'rgb(2, 0, 36)','botella': 'rgb(74, 140, 57)','metal': 'rgb(149, 154, 148)','oro': 'rgb(235, 204, 121)','plata': 'rgb(184, 184, 184)','marino': 'rgb(24, 79, 159)','rosa': 'rgb(242, 175, 255)','marron': 'rgb(111, 62, 16)','multi': 'linear-gradient(90deg, #d53369 0%, #daae51 100%)','rosado': 'rgb(255, 192, 203)','hielo': 'rgb(244, 251, 241)','fucsia': 'rgb(215, 55, 209)','rojo': 'rgb(232, 5, 5)','dorado': 'rgb(230, 219, 123)','mostaza': 'rgb(231, 199, 37)','taupe': 'rgb(154, 121, 71)','cromo': 'rgb(230, 228, 209)','burdeos': 'rgb(100, 28, 52)','azul-jean': 'rgb(0, 68, 255)','oliva': 'rgb(76, 108, 61)','amarillo': 'rgb(255, 217, 20)','gris': 'rgb(194, 194, 194)','cava': 'rgb(253, 255, 223)','tierra': 'rgb(228, 126, 0)','kaki': 'rgb(106, 95, 49)','cielo': 'rgb(195, 224, 255)',};

    this.images = {'leopardo': 'url("//sienazapatos.com/cdn/shop/files/leopardo_68x.png?v=18194013251418410912")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
